module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkInQuery"
  }, [_c('div', {
    staticClass: "fixed-content"
  }, [_c('div', {
    staticClass: "tabBtn"
  }, [_c('mt-navbar', {
    staticClass: "navBar",
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "1"
    }
  }, [_vm._v("在宿")]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "2"
    }
  }, [_vm._v("不在宿")]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "3"
    }
  }, [_vm._v("24小时无活动")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-content scroll-content1"
  }, [(_vm.list.length == 0) ? _c('div', {
    staticClass: "noData"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "gridWarp bg-appStyle color-fff"
  }, [_c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("姓名")]), _vm._v(" "), (_vm.selected != 3) ? _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("状态")]) : _vm._e(), _vm._v(" "), (_vm.selected == 3) ? _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("最后方向")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("楼栋")]), _vm._v(" "), _c('div', {
    staticClass: "gridCell flex-1 bold"
  }, [_vm._v("最后时间")])]), _vm._v(" "), _c('div', _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gridWarp bg-fff"
    }, [_c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.selected != 3) ? _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.inDormStatus))]) : _vm._e(), _vm._v(" "), (_vm.selected == 3) ? _c('div', {
      staticClass: "gridCell flex-1"
    }, [(item.inOutFlag == 1) ? _c('span', [_vm._v("进")]) : (item.inOutFlag == 2) ? _c('span', [_vm._v("出")]) : _c('span', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [_vm._v(_vm._s(item.areaName))]), _vm._v(" "), _c('div', {
      staticClass: "gridCell flex-1"
    }, [(item.actionTime) ? _c('span', [_vm._v(_vm._s(item.actionTime))]) : _c('span', [_vm._v("无")])])])
  }), 0)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-bottom": "7rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/default-null.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时无相关数据")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-319e5bda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DormitoryManagement.vue
// module id = 843
// module chunks = 1